import { render, staticRenderFns } from "./consultingModify.vue?vue&type=template&id=6f156320&scoped=true"
import script from "./consultingModify.vue?vue&type=script&lang=js"
export * from "./consultingModify.vue?vue&type=script&lang=js"
import style0 from "./consultingModify.vue?vue&type=style&index=0&id=6f156320&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f156320",
  null
  
)

export default component.exports